import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface ModifyModalStateParameter {
    isOpen: boolean;
}
type HandlerType = CustomHandler<ModifyModalStateParameter>;

export const DispatchModifyUpgradeToBusniessAccountModalOpenState: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/ModifyUpgradeToBusinessModelOpenState",
        value: props.parameter.isOpen,
    });
};

export const chain = [DispatchModifyUpgradeToBusniessAccountModalOpenState];

const modifyUpgradeToBusniessAccountModalOpenState = createHandlerChainRunner(
    chain,
    "ModifyUpgradeToBusniessAccountModalOpenState",
);
export default modifyUpgradeToBusniessAccountModalOpenState;
